import { render } from "./D_chanAlimList_homepage.vue?vue&type=template&id=73424c7c&scoped=true"
import script from "./D_chanAlimList_homepage.vue?vue&type=script&lang=js"
export * from "./D_chanAlimList_homepage.vue?vue&type=script&lang=js"

import "./D_chanAlimList_homepage.vue?vue&type=style&index=0&id=73424c7c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73424c7c"]])

export default __exports__